module.exports = __webpack_public_path__ + "static/media/portfolio-text-editor.27266855.png";